import { atom } from "jotai";

import { HookTrackEvent } from "@/utils/Analytics/events";

import { VerifiedAuthenticationModalStepState } from "../types";

export const defaultVerificationModalStepState: VerifiedAuthenticationModalStepState =
  {
    step: "Initial",
    backStep: null,
  };

export const VerificationModalStepStateAtom =
  atom<VerifiedAuthenticationModalStepState>(defaultVerificationModalStepState);

export const VerificationModalCompleteActionAtom = atom<
  ((clubSlug?: string) => void) | null
>(null);

export const VerificationModalTrackEventAtom = atom<HookTrackEvent | null>(
  null
);
